import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="session-timeout-timer"
export default class extends Controller {
  static targets = [ "display" ]
  static values = { time: Number, warningLimit: Number, timeoutMessage: String }

  initialize() {
    this.time = this.timeValue
    this.isDisplay = false
  }

  connect() {
    this.intervalId = setInterval(() => {
      this.timer()
    }, 1000)
  }

  disconnect() {
    clearInterval(this.intervalId)
  }

  // 制限時間
  timer() {
    this.time = this.time - 1

    if (this.time < 0) {
      clearInterval(this.intervalId)
      confirm(this.timeoutMessageValue)
    } else if (this.time < this.warningLimitValue) {
      if (this.isDisplay == false) {
        this.isDisplay = true
        this.element.classList.remove('d-none')
      }
      this.displayTarget.innerHTML = this.formatTime(this.time)
    }
  }

  formatTime(time) {
    var hour = parseInt(time / 3600)
    var min = parseInt((time / 60) % 60)
    var sec = time % 60

    if(hour < 10) { hour = "0" + hour }
    if(min < 10) { min = "0" + min }
    if(sec < 10) { sec = "0" + sec }

    return hour + ':' + min + ':' + sec
  }
}
